/**
 * 网络请求
 */
const _getHeaderUrl = Symbol('_getHeaderUrl')
import signatureUtil from './HSSignatureUtil'
import rootHttpClient from '@/http/interceptors'
const $tt = key => {
  return key
}
// 生成一个时间戳
const time = new Date()
const timeSing = `${time.getFullYear()}.${time.getMonth() +
  1}.${time.getDate()}.${time.getHours()}.${time.getMinutes()}`
let file_name_down = timeSing + '.xlsx' // 默认文件名
class HSHttpClient {
  // parm1:路由参数 parm2问号参数 parm3：body参数
  constructor (url, parm1 = {}, parm2 = {}, parm3 = '') {
    this.urlParams = new Map()
    this.realUrl = url
    this[_getHeaderUrl](parm1) // 处理路由参数
    this.newUrl = this.getSignRequestUrl(parm2, parm3) // 处理问号参数和body参数
  }
  [_getHeaderUrl] (params) {
    for (const key in params.data) {
      params.routerUrl = params.routerUrl.replace(
        key,
        encodeURIComponent(params.data[key])
      )
      this.urlParams.set(key, params.data[key])
    }
    if (params.routerUrl) {
      this.realUrl = this.realUrl + params.routerUrl + '/'
    }
  }
  getSignRequestUrl (paramsObj, body = '') {
    let returnUrl = ''
    let tempParamsUrl = ''
    if (paramsObj) {
      for (var key in paramsObj) {
        const val = encodeURIComponent(paramsObj[key])
        if (val !== '') {
          tempParamsUrl += `&${key}=${val}`
          this.urlParams.set(key, paramsObj[key])
        }
      }
    }
    const timestamp = signatureUtil.getTimeStamp()
    const nonce = signatureUtil.getRandom(5)
    const signaPlain = signatureUtil.makeSignPlain(
      this.urlParams,
      body,
      timestamp,
      nonce
    )
    if (this.realUrl.includes('/ref')) {
      returnUrl = this.realUrl
    } else {
      returnUrl = `${this.realUrl}?timestamp=${timestamp}&nonce=${nonce}&signature=${signaPlain}${tempParamsUrl}`
    }
    return returnUrl
  }
}
const API = {
  /**
   * get // routerParms:路由参数；interrogationParms：问号参数
   * @param {*} urls
   * @param {*} routerParms
   * @param {*} interrogationParms
   */
  get (urlOld, routerParms = {}, interrogationParms = {}) {
    const Single = new HSHttpClient(urlOld, routerParms, interrogationParms)
      .newUrl
    return rootHttpClient.rootModule.get(Single)
  },
  get_singe_url (urlOld, routerParms = {}, interrogationParms = {}) {
    const Single = new HSHttpClient(urlOld, routerParms, interrogationParms)
      .newUrl
    return Single
  },
  get_file_blob (urlOld, routerParms = {}, interrogationParms = {}) {
    const Single = new HSHttpClient(urlOld, routerParms, interrogationParms)
      .newUrl
    return rootHttpClient.rootModule.request(
      'get',
      Single,
      null,
      null,
      (headers = null),
      { responseType: 'blob' }
    )
  },
  get_file_blob_down (
    urlOld,
    routerParms = {},
    interrogationParms = {},
    filename = $tt('下载的excle')
  ) {
    const Single = new HSHttpClient(urlOld, routerParms, interrogationParms)
      .newUrl
    rootHttpClient.rootModule
      .request('get', Single, null, null, (headers = null), {
        responseType: 'blob'
      })
      .then(data => {
        const url = window.URL.createObjectURL(new Blob([data.data]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', filename)
        link.click()
      })
  },
  down_Template (file_name) {
    this.get_file_blob('mesAPI/file/demo/', {}, { file_name }).then(data => {
      const url = window.URL.createObjectURL(new Blob([data.data]))
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', file_name)
      // document.body.appendChild(link)
      link.click()
    })
  },

  down_Excel_sysInit_old (export_type) {
    const routerParms = {
      routerUrl: 'export_type',
      data: {
        export_type
      }
    }
    this.get_file_blob('mesAPI/system_init/export_excel/', routerParms).then(
      data => {
        const url = window.URL.createObjectURL(new Blob([data.data]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', file_name_down)
        link.click()
      }
    )
  },
  isJson (obj) {
    // 判定是否是json
    const isjson =
      typeof obj === 'object' &&
      Object.prototype.toString.call(obj).toLowerCase() === '[object object]' &&
      !obj.length
    return isjson
  },
  down_Excel_sysInit (export_type, ids = []) {
    const bodyParm = {
      export_type: export_type,
      ids: ids
    }
    this.postFiles('mesAPI/system_init/export_excel/', {}, {}, bodyParm).then(
      data => {
        const url = window.URL.createObjectURL(new Blob([data.data]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', file_name_down)
        link.click()
      }
    )
  },
  postFiles (
    urlOld,
    routerParms = {},
    interrogationParms = {},
    bodyParms = {}
  ) {
    const Single = new HSHttpClient(urlOld, routerParms)
    const urlNew = Single.getSignRequestUrl(interrogationParms, bodyParms)
    return rootHttpClient.rootModule.request(
      'post',
      urlNew,
      bodyParms,
      null,
      (headers = null),
      { responseType: 'blob' }
    )
  },
  /**
   * post routerParms:路由参数；interrogationParms：问号参数，data：body参数
   * @param {*} urls
   * @param {*} routerParms
   * @param {*} interrogationParms
   * @param {*} bodyParms
   */
  post (urlOld, routerParms = {}, interrogationParms = {}, bodyParms = {}) {
    const Single = new HSHttpClient(urlOld, routerParms)
    const urlNew = Single.getSignRequestUrl(interrogationParms, bodyParms)
    return rootHttpClient.rootModule.post(urlNew, bodyParms)
  },
  delete (urlOld, routerParms = {}, interrogationParms = {}, bodyParms = {}) {
    const Single = new HSHttpClient(urlOld, routerParms)
    const urlNew = Single.getSignRequestUrl(interrogationParms, bodyParms)
    return rootHttpClient.rootModule.delete(urlNew, { data: bodyParms })
  },
  put (urlOld, routerParms = {}, interrogationParms = {}, bodyParms = {}) {
    const Single = new HSHttpClient(urlOld, routerParms)
    const urlNew = Single.getSignRequestUrl(interrogationParms, bodyParms)
    return rootHttpClient.rootModule.put(urlNew, bodyParms)
  },
  post_file (urlOld, data = {}, routerParms = {}, interrogationParms = {}) {
    const url = this.get_singe_url(urlOld, routerParms, interrogationParms)
    return rootHttpClient.rootModule.post(url, data)
  },
  win_open_down_file (type) {
    window.open(`/mesAPI/system_init/export_excel/${type}/`)
  }
}

export default API



// WEBPACK FOOTER //
// ./src/utils/sha256/myHttpClient.js